import { render, staticRenderFns } from "./PersonalHistory.vue?vue&type=template&id=4c2c0c9e"
import script from "./PersonalHistory.vue?vue&type=script&lang=js"
export * from "./PersonalHistory.vue?vue&type=script&lang=js"
import style0 from "./PersonalHistory.vue?vue&type=style&index=0&id=4c2c0c9e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports